import { flatten, last } from '_';
import { mixin }         from 'utils/util';
import HasPrettyTime     from 'mixins/has_pretty_time';
import CompilerMethods   from 'mixins/descriptor_compiler_methods';

const EventCompiler = function(events, slideRoot) {
  this.events    = flatten([events]);
  this.slideRoot = slideRoot;
  this.isValid   = !!events[0];
};

EventCompiler.prototype = mixin(HasPrettyTime, CompilerMethods, {
  compile() {
    this.buildEvents();
    return this;
  },
  buildEvents() {
    if(!this.isValid) return this;
    this.events = this.events.reduce((acc, event) => {
      switch(event.type) {
        case 'unlockVideos':
          acc.locks.push(event);
          break;
        default:
          console.warn(`Unidentified event type: ${event.type} in stream`, event);
      }
      if(event.chapterTitle) {
        const lastTitle = last(acc.chapters) && last(acc.chapters).title;
        if(lastTitle !== event.chapterTitle) {
          acc.chapters.push({
            title: event.chapterTitle,
            startTime: event.startTime,
            // this is for the webmd video lib.
            startSeconds: this.secondsFromPrettyTime(event.startTime)
          });
        }
      }
      return acc;
    }, { locks: [ ]});

    return this;
  },

  getEvents() {
    return this.isValid? this.events : { };
  }
});
export default EventCompiler;



// WEBPACK FOOTER //
// ./modules/descriptor/event_compiler.js